import { useIntl } from '@capsicum/common';
import { GenericDrawer } from '@capsicum/common-web';

export type CHZUpgradeDrawerProps = {
	onButtonPress: () => void;
	onSecondaryActionOnButtonPress: () => void;
	testID: string;
};

export const CHZUpgradeDrawer = ({ onButtonPress, onSecondaryActionOnButtonPress, testID }: CHZUpgradeDrawerProps) => {
	const { $t } = useIntl();

	const cHZUpgradeDrawerData = {
		buttonText: $t('wallet.receive.chzUpgradeDrawer.continueButton'),
		description: $t('wallet.receive.chzUpgradeDrawer.text'),
		isButtonOnRow: false,
		onButtonPress,
		onSecondaryActionOnButtonPress,
		secondaryActionButtonText: $t('wallet.receive.chzUpgradeDrawer.cancelButton'),
		testID: testID,
		title: $t('wallet.receive.chzUpgradeDrawer.title')
	};

	return <GenericDrawer {...cHZUpgradeDrawerData} />;
};
